"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseShop = void 0;
const vendor_1 = require("../../vendor");
class BaseShop {
    constructor(params) {
        this._shopCreatorAddress = params.shopCreatorAddress;
        this._treasuryMint = params.treasuryMint;
        this._env = params.env;
        this._programId = params.programId;
        this._settings = params.settings;
        this._baseUnitsPerCurrency = Math.pow(10, this._settings.currencyDecimals);
    }
    get candyShopCreatorAddress() {
        return this._shopCreatorAddress;
    }
    get treasuryMint() {
        return this._treasuryMint;
    }
    get programId() {
        return this._programId;
    }
    get settings() {
        return this._settings;
    }
    get env() {
        return this._env;
    }
    get baseUnitsPerCurrency() {
        return this._baseUnitsPerCurrency;
    }
    get currencyDecimals() {
        return this._settings.currencyDecimals;
    }
    get currencySymbol() {
        return this._settings.currencySymbol;
    }
    get priceDecimals() {
        return this._settings.priceDecimals;
    }
    get priceDecimalsMin() {
        return this._settings.priceDecimalsMin;
    }
    get volumeDecimals() {
        return this._settings.volumeDecimals;
    }
    get volumeDecimalsMin() {
        return this._settings.volumeDecimalsMin;
    }
    get explorerLink() {
        return this._settings.explorerLink;
    }
    // Only inheritors can call this configuration
    static configEndpoint(env) {
        (0, vendor_1.configBaseUrl)((0, vendor_1.getBaseUrl)(env));
    }
}
exports.BaseShop = BaseShop;
